import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function DownloadSheet({
  open,
  dismiss,
  title,
  disabled,
  onConfirm,
}: {
  open: boolean;
  dismiss: () => void;
  title: string;
  disabled: boolean;
  onConfirm: () => void;
}) {
  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Baixar mapa"
      className="agro-ci-area-download-sheet"
    >
      <div className="agro-ci-area-download-body">
        <div className="agro-ci-area-download-icon">
          <Icon iconType="download" color={cssVar('text-strong')} size="large" />
        </div>
        <p className="agro-ci-area-download-text">
          O mapa
          {' '}
          <b>{title}</b>
          {' '}
          será salvo como imagem PNG no seu dispositivo.
        </p>
      </div>
      <div className="agro-ci-area-download-footer">
        <button
          type="button"
          className="agro-ci-area-download-confirm"
          disabled={disabled}
          onClick={onConfirm}
        >
          Baixar PNG
        </button>
        <button
          type="button"
          className="agro-ci-area-download-cancel"
          onClick={dismiss}
        >
          Cancelar
        </button>
      </div>
    </BottomSheet>
  );
}
